import React from "react";
import { dataPolicy } from "../lib/dataContent";

export default function DataPrivacy() {
  return (
    <div className="flex-1">
      <section className="w-full px-6 py-3 md:px-12 md:py-5 lg:px-20 lg:py-8 xl:px-28">
        <h2 className="mb-4 text-base text-primaryColor md:mb-6 md:text-lg lg:mb-8 lg:text-xl xl:text-2xl">
          Global GDPR-Compliant Privacy Policy
        </h2>
        <h2 className="mb-4 text-base text-primaryColor md:mb-6 md:text-lg lg:mb-8 lg:text-xl xl:text-2xl">
          Access Crewing Solutions Privacy Policy
        </h2>
        <h3 className="mb-4 text-sm text-primaryColor md:mb-6 md:text-base lg:mb-8 lg:text-lg xl:text-xl">
          Effective Date: {dataPolicy?.effectiveDate}
        </h3>
        <p className="mb-4 text-sm text-primaryColor md:mb-6 md:text-base lg:mb-8 lg:text-lg xl:text-xl">
          Access Crewing Solutions is committed to protecting the privacy of
          individuals and adhering to applicable data protection laws, including
          the{" "}
          <span className="font-bold">
            General Data Protection Regulation (GDPR)
          </span>{" "}
          and other global privacy standards.
        </p>
        <ul className="list-decimal space-y-4 text-sm md:space-y-6 md:text-base lg:space-y-8 lg:text-lg xl:text-xl">
          {dataPolicy?.sections?.map((section, index) => {
            return (
              <li key={index}>
                <h3 className="mb-1 font-bold md:mb-2 lg:mb-3">
                  {section?.title}
                </h3>
                <p className="text-xs md:text-sm lg:text-base xl:text-lg">
                  {section?.body}
                </p>
                <ul className="list-disc text-xs md:text-sm lg:text-base xl:text-lg">
                  {section?.bodyList?.map((item, index) => {
                    return <li key={index}>{item}</li>;
                  })}
                </ul>
              </li>
            );
          })}
        </ul>
      </section>
    </div>
  );
}
